export async function ChangeToPromise (funcion:() => void): Promise<void> {
    return new Promise((resolve) => {
      funcion();
      resolve();
    });
  }